import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

export const useAppId = () => {
  const [appId, setAppId] = useState('')

  useEffect(() => {
    let storedAppId = localStorage.getItem('app_id')
    if (!storedAppId) {
      storedAppId = uuidv4() // generate a new unique ID
      localStorage.setItem('app_id', storedAppId)
    }
    setAppId(storedAppId)
  }, [])

  return appId
}
